// Module
var code = "<label> <div class=\"ToolBarPreview\"> <i class=\"fa fa-link\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </div> </label>";
// Exports
export default code;